import React from 'react';
import appParameters from '../../components/utils/AppParameters';

export const InternetExplorerAlert = React.createClass({
    render () {
        const width = this.props.windowWidth - 200;
        const height = 200;

        const menuStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: this.props.windowHeight / 2 - height / 2,
            left: this.props.windowWidth / 2 - width / 2
        };

        const spanStyle = {
            position: 'absolute',
            width: width,
            height: height,
            fontSize: 20,
            WebkitUserSelect: 'none',
            userSelect: 'none',
            textAlign: 'center',
            cursor: 'default',
            top: 0
        };

        //var text = locales.getCaption('internetExplorerAlert', 'other');
        // for Internet Explorer for some reason the captions can't be loaded properly using i18Service
        var text = 'INTERNET EXPLORER is not supported! Please load Cartoonist using Chrome, Firefox, Opera, Microsoft Edge or Safari!';

        switch (appParameters.locale) {
            case 'en_US': {
                break;
            }
            case 'da_DK': {
                text = ' INTERNET EXPLORER understøttes ikke. Brug venligst Cartoonist med Chrome, Firefox, Opera, Microsoft Edge eller Safari! ';
                break;
            }
            case 'de_DE': {
                text = 'INTERNET EXPLORER wird nicht unterstützt. Für Cartoonist nutzen Sie bitte Chrome, Firefox, Opera, Microsoft Edge oder Safari! ';
                break;
            }
            case 'es_ES': {
                break;
            }
            case 'fi_FI': {
                break;
            }
            case 'fr_FR': {
                break;
            }
            case 'nl_NL': {
                break;
            }
            case 'nb_NO': {
                text = 'INTERNET EXPLORER støttes ikke! Vennligst bruk Chrome, Firefox, Microsoft Edge, Safari eller Opera. ';
                break;
            }
            case 'sv_SE': {
                text = ' Internet Explorer stöds inte! Använd Cartoonist med Chrome, Firefox, Opera, Microsoft Edge eller Safari! ';
                break;
            }
        }

        return (
            <div style={menuStyle}>
                <span style={spanStyle}>{text}</span>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/InternetExplorerAlert.js
 **/